import { TlfArsListingReadDto, TlfArsTableReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { VARIANT_UPDATEABLE_KEYS } from "./VariantUpdateableKeys";

/**
 * The fields that a variant may override for one concrete ARS DTO.
 */
export type VariantUpdateable<
  T extends TlfArsTableReadDto | TlfArsListingReadDto = TlfArsTableReadDto | TlfArsListingReadDto,
> = T extends unknown ? Pick<T, (typeof VARIANT_UPDATEABLE_KEYS)[number]> : never;

/**
 * Reduce a master ARS table to only the properties a variant may override.
 *
 * @param tlfItem - The master ARS table to reduce
 * @returns An object containing only the variant updateable properties
 */
export const pickVariantUpdateable = <T extends TlfArsTableReadDto | TlfArsListingReadDto>(
  tlfItem: T,
): Partial<VariantUpdateable<T>> =>
  Object.fromEntries(VARIANT_UPDATEABLE_KEYS.map((key) => [key, tlfItem[key]])) as Partial<
    VariantUpdateable<T>
  >;
